module.exports = __webpack_public_path__ + "img/fi-rr-sign-in.b7559f2d.svg";